export default __webpack_public_path__ + "e418aa5de1995f95daf77ba9ce3f436b.png";